import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http: HttpClient) { }

  searchDoctors(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/search-doctors`;
    return this.http.post(url, value);
  }

  addDoctorToTerritory(doctorId: any, locationId: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/add-doctor-to-location/${doctorId}/${locationId}`;
    return this.http.post(url, {});
  }

  searchConsumers(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/search-consumers`;
    return this.http.post(url, value);
  }

  getOpenTicketStatistics(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/open-tickets-statistics`;
    return this.http.get(url);
  }

  getOpenTicketAssignments(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/ticket-assignments`;
    return this.http.get(url);
  }

  getInboundCallClassifications(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/inbound-call-classifications`;
    return this.http.get(url);
  }
  getFollowUpCallClassifications(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/follow-up-call-classifications`;
    return this.http.get(url);
  }

  doServiceTagging(contactId: any, stockistId: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/service-tagging/${contactId}/${stockistId}`;
    return this.http.post(url, {});
  }

  callStockist(id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/call-back-stockist/${id}`;
    return this.http.get(url);
  }

  getDayWiseCalls(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/day-wise-calls`;
    return this.http.get(url);
  }

  getOrders(): Observable<any> {
    const channel = 'Call Center';
    const url = `${environment.apiOrigin}/api/customer-service/orders/${channel}`;
    return this.http.get(url);
  }

  saveDoctorDetails(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/doctors`;
    return this.http.put(url, value);
  }

  searchHospitals(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/search-hospitals`;
    return this.http.post(url, value);
  }

  addHospitalToTerritory(hospitalId: string, locationId: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/add-hospital-to-location/${hospitalId}/${locationId}`;
    return this.http.post(url, {});
  }

  saveHospitalDetails(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/hospitals`;
    return this.http.put(url, value);
  }

  sendOtp(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/send-otp-for-mobile-verification`;
    return this.http.post(url, value);
  }

  verifyOtp(mobileNumber: number, otpInfo: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/otp-verification`;
    otpInfo.mobileNumber = mobileNumber;
    return this.http.post(url, otpInfo);
  }

  saveCustomer(customer: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/save-customer`;
    return this.http.post(url, customer);
  }

  getCustomerDetails(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/customer-details`;
    return this.http.post(url, criteria);
  }

  requestDrugLevelTests(id: any, drugLevelTestsList: Array<any>): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/request-drug-level-tests/${id}`;
    return this.http.post(url, drugLevelTestsList);
  }

  getCallsCount(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/today-calls`;
    return this.http.get(url);
  }

  getExecutivesOnCalls(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/executives-on-call`;
    return this.http.get(url);
  }

  getCustomerFeedbackStatistics(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/customer-feedback-statistics`;
    return this.http.get(url);
  }

  getDayWiseCurrentMonthSales(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/day-wise-monthly-sales`;
    return this.http.get(url);
  }

  getChannelCurrentMonthSales(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/channel-wise-monthly-sales`;
    return this.http.get(url);
  }

  getProductWiseCurrentMonthSales(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/product-wise-monthly-sales`;
    return this.http.get(url);
  }

  getStoreWiseCurrentMonthSales(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/store-wise-monthly-sales`;
    return this.http.get(url);
  }

  getDayWiseCurrentMonthOrders(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/day-wise-monthly-orders`;
    return this.http.get(url);
  }

  getStateWiseCurrentMonthSales(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/state-wise-monthly-sales`;
    return this.http.get(url);
  }

  getMonthlyCustomers(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/monthly-customer-count`;
    return this.http.get(url);
  }

  getTransplantRecord(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/my-transplant-record`;
    return this.http.get(url);
  }

  getConsumerTransplantRecord(contactId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/consumer-transplant-record/${contactId}`;
    return this.http.get(url);
  }

  uploadDocuments(files: any, image: any, activePatient: any, activeDoctor: any): Observable<any> {
    const patient: any = {};
    patient.contactId = activePatient.id;
    patient.name = activePatient.name;
    patient.mobileNumber = activePatient.mobileNumber;
    patient.emailAddress = activePatient.emailAddress;
    let doctor: any = {};
    if (activeDoctor) {
      doctor.contactId = activeDoctor.id;
      doctor.name = activeDoctor.name;
      doctor.mobileNumber = activeDoctor.mobileNumber;
      doctor.emailAddress = activeDoctor.emailAddress;
    } else {
      doctor = {};
    }
    const url = `${environment.apiOrigin}/api/customer-service/upload-document`;
    const formData: FormData = new FormData();
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < files.length; i++) {
      const fileName = files[i].name;
      if (!fileName.endsWith('jpg') && !fileName.endsWith('png') && !fileName.endsWith('jpeg') && !fileName.endsWith('gif')) {
        formData.append('files', files[i], files[i].name);
      } else {
        formData.append('fileName', fileName);
      }
    }
    formData.append('document', image);
    formData.append('documentType', 'prescription');
    formData.append('patient', JSON.stringify(patient));
    formData.append('doctor', JSON.stringify(doctor));

    return this.http.post(url, formData);
  }

  getPastPrescriptions(id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/uploaded-documents/${id}`;
    return this.http.get(url);
  }

  saveTransplantRecord(value: any, id: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/transplant-record/${id}`;
    return this.http.post(url, value);
  }

  downloadPrescription(fileId: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/download-document/${fileId}`;
    return this.http.get(url);
  }

  searchConsumerByMobileNumber(mobileNumber: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/search-customer-by-mobile/${mobileNumber}`;
    return this.http.get(url);
  }

  getPriorityCustomerCities(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/priority-customer-cities`;
    return this.http.get(url);
  }

  getConsumerById(contactId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/consumer-view/${contactId}`;
    return this.http.get(url);
  }




  mergeConsumerById(consumerDetails: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/patientmerge/patient-merge`;
    return this.http.put(url, consumerDetails);
  }
  deleteConsumerById(contactId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/patientmerge/delete-patient/${contactId}`;
    return this.http.delete(url);
  }

  getPriorityCustomerStates(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/priority-customer-states`;
    return this.http.get(url);
  }

  searchConsumersByCityStateOrSearchText(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/search-consumers-by-city-state-search-text`;
    return this.http.post(url, value);
  }

  callCustomer(contactId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/call-customer/${contactId}`;
    return this.http.get(url);
  }

  updateName(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/update-name`;
    return this.http.post(url, value);
  }

  getOutboundCallSummary(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/outbound-call-summary`;
    return this.http.post(url, criteria);
  }

  refreshOutboundCallSummary(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/refresh-outbound-call-summary`;
    return this.http.get(url);
  }

  getCallHistory(contactId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/call-history/${contactId}`;
    return this.http.get(url);
  }

  getDrugLevelMarkerRequestsSummary(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/drug-level-marker-requests-summary-by-payment-terms`;
    return this.http.post(url, criteria);
  }
  getDrugLevelMarkerRequestsSummaryByLab(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/drug-level-marker-requests-summary-by-lab`;
    return this.http.post(url, criteria);
  }

  getHealthRecordDocuments(contactId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/health-record-documents/${contactId}`;
    return this.http.get(url);
  }

  getStockiestInvoices(contactId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/stockiest-invoice/${contactId}`;
    return this.http.get(url);
  }

  getDrugLevelMarkerRequestsSummaryByStatus(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/drug-level-marker-requests-summary-by-status`;
    return this.http.post(url, criteria);
  }

  getDrugLevelMarkerRequestsDatabase(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/marketplace/drug-level-database`;
    return this.http.post(url, criteria);
  }

  saveCallSummary(callSummary: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/call-summary`;
    return this.http.post(url, callSummary);
  }

  getCallSummary(contactId: string): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/call-summary/${contactId}`;
    return this.http.get(url);
  }

  getOutboundCallsOutcomeSummary(criteria: any, inactiveCohort: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/outbound-call-outcome-summary/${inactiveCohort}`;
    return this.http.post(url, criteria);
  }

  getInboundCallSummary(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/inbound-calls-summary?fromDate=${criteria}`;
    return this.http.get(url);
  }


  fetchCustomers(criteria: any, inactiveCohort: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/outbound-call-outcome-summary/customers/${inactiveCohort}`;
    return this.http.post(url, criteria);
  }
  fetchCustomersInbound(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/inbound-calls-summary-details`;
    return this.http.post(url, criteria);
  }

  getMonthWiseMembershipTierCount(param: {}): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/membership-tier-count-month-wise`;
    return this.http.post(url, param);
  }

  getInactiveCohort(): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/inactive-cohort-count`;
    return this.http.get(url);
  }

  getDayWiseEnrolment(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/day-wise-customer-enrolment`;
    return this.http.post(url, criteria);
  }

  getDayWiseTransplants(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/day-wise-doctor-transplants`;
    return this.http.post(url, criteria);
  }

  getLabWiseDrugLevelCost(criteria: any): Observable<any> {

    const url = `${environment.apiOrigin}/api/customer-service/lab-wise-test-cost`;
    return this.http.post(url, criteria);
  }

  getRetialerTranscribe(criteria: any): Observable<any> {

    const url = `${environment.apiOrigin}/api/marketplace/Get-Invoce-Transcription-Report?fromDate=${criteria.fromDate}&toDate=${criteria.toDate}`;
    return this.http.get(url);
  }

  getOutboundCallsAgentPerformance(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/customer-outbound-calls-agent-performance`;
    return this.http.post(url, criteria);
  }


  getDenovoCustomers(criteria: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/denovo-customers`;
    return this.http.post(url, criteria);
  }
  getDrugLevelMarkerRequestsSummaryByTerritory(value: any): Observable<any> {
    const url = `${environment.apiOrigin}/api/customer-service/drug-level-marker-requests-summary-by-territory`;
    return this.http.post(url, value);
  }

  ////////////////////////////////////////// CUSTOMER SERVICE V2 //////////////////////////////////////////////////////////////////////////////////////////////////////////////

  getCustomerByDateRange(fronDate: Date, toDate: Date) {

    const url = `${environment.apiOrigin}/api/customer-service/get-customer-by-date-range?fromDate=${fronDate}&toDate=${toDate}`;
    return this.http.get<any>(url).pipe(map(res => res));
  }
}
